import clsx from 'clsx'
import { BaseModalProps, LeverageRatioColumnChart, Modal, Tabs } from 'components/core-v2'
import { useState } from 'react'
import { formatCurrencyFull } from 'utilities/currency'

import { CURRENCY } from '../../../../../const'
import { useFilteredGetByTenantAccountDashboardQuery } from '../../../../../modules/reporting/utils/useFilteredNotes'
import { TargetVolatilityColumnChart } from '../../charts/column-chart/target-volatility-column-chart'
import { formatStrategy } from '../__utils__/format-strategy'
import classes from '../modal.module.scss'

const Body = ({ onClose }: Omit<BaseModalProps, 'isOpen'>) => {
  const { data, isLoading } = useFilteredGetByTenantAccountDashboardQuery()
  const [tab, setTab] = useState('leverage-ratio')

  if (isLoading) return null

  const { strategies } = data
  const strategy = strategies.find(strategy => strategy.strategyName === 'Volatility Control')
  const { leverageRatios, targetVolatilities } = formatStrategy(strategy)

  const totalValue = formatCurrencyFull(strategy.zarValue, CURRENCY)

  return (
    <>
      <Modal.Header id="vol-control-modal-label" onClose={onClose}>
        <h2>Volatility control</h2>
      </Modal.Header>
      <Modal.Body className="mb-4">
        <div className={clsx(classes.stats, 'mb-8')}>
          <span className="mr-8">
            Total value: <strong>{totalValue}</strong>
          </span>
          <span>
            Total trades: <strong>{strategy.numberOfActiveAccounts}</strong>
          </span>
        </div>
        <Tabs.List ruleClassName="mb-8" spacing="md">
          <Tabs.Tab
            isSelected={tab === 'leverage-ratio'}
            value="leverage-ratio"
            onClick={() => setTab('leverage-ratio')}
          >
            Leverage ratio
          </Tabs.Tab>
          <Tabs.Tab
            isSelected={tab === 'target-volatility'}
            value="target-volatility"
            onClick={() => setTab('target-volatility')}
          >
            Target volatility
          </Tabs.Tab>
        </Tabs.List>
        {tab === 'leverage-ratio' && (
          <Tabs.Panel value="leverage-ratio">
            <LeverageRatioColumnChart leverageRatios={leverageRatios} />
          </Tabs.Panel>
        )}
        {tab === 'target-volatility' && (
          <Tabs.Panel value="target-volatility">
            <TargetVolatilityColumnChart targetVolatilities={targetVolatilities} />
          </Tabs.Panel>
        )}
      </Modal.Body>
    </>
  )
}

export const VolControlModal = ({ isOpen, onClose }: BaseModalProps) => (
  <Modal.Wrapper
    aria-labelledby="vol-control-modal-label"
    isOpen={isOpen}
    width="lg"
    onClose={onClose}
  >
    <Body onClose={onClose} />
  </Modal.Wrapper>
)
